import { CSSProperties, FC, useMemo } from 'react';

import {
  Icon,
  Typography,
} from '@beeline/design-system-react/extracted-styles';
import { Icons } from '@beeline/design-tokens/js/iconfont';

import clsx from 'clsx';
import { Parking } from 'src/types';

import classes from './ParkingPlace.module.scss';

const guestCoef = 0.73;
const gapCoef = 0.5;

export interface ContentProps {
  item: Parking;
  contentClassName?: string;
  icon?: Icons;
}

export const Content: FC<ContentProps> = ({ item, icon, contentClassName }) => {
  const { fontSize, rotation, title, guest } = item;

  const fontSizePx = `${fontSize}px`;
  const gapPx = `${fontSize * gapCoef}px`;

  const contentStyle = useMemo(
    (): CSSProperties => ({
      transform: `translateY(${rotation ? 100 : -100}%)`,
      justifyContent: rotation ? 'start' : 'end',
      padding: fontSizePx,
      gap: gapPx,
      flexDirection: rotation ? 'column' : 'column-reverse',
    }),
    [fontSizePx, gapPx, rotation],
  );

  const contentMainStyle = useMemo(
    (): CSSProperties => ({
      gap: fontSizePx,
    }),
    [fontSizePx],
  );

  const titleStyle = useMemo(
    (): CSSProperties => ({
      fontSize: fontSizePx,
      lineHeight: fontSizePx,
    }),
    [fontSizePx],
  );

  const iconStyle = useMemo(
    (): CSSProperties => ({
      fontSize: fontSizePx,
      width: fontSizePx,
      height: fontSizePx,
      lineHeight: fontSizePx,
    }),
    [fontSizePx],
  );

  const guestSizePx = `${fontSize * guestCoef}px`;

  const guestStyle = useMemo(
    (): CSSProperties => ({
      fontSize: guestSizePx,
      lineHeight: guestSizePx,
    }),
    [guestSizePx],
  );

  return (
    <div className={classes.content} style={contentStyle}>
      <div className={classes.contentMain} style={contentMainStyle}>
        {icon && (
          <Icon
            className={clsx(classes.text, contentClassName)}
            style={iconStyle}
            iconName={icon}
          />
        )}
        <Typography
          className={clsx(classes.text, contentClassName)}
          variant='body3'
          style={titleStyle}
        >
          {title}
        </Typography>
      </div>

      {guest && (
        <Typography
          className={clsx(classes.text, contentClassName)}
          variant='body3'
          style={guestStyle}
        >
          Гостевое
        </Typography>
      )}
    </div>
  );
};
